


// THIS CODE IS GENERATED.  CHANGES MADE TO THIS FILE WILL BE LOST.

import { Entity, ApplicationConfiguration, Address, Phone, Country, GeographicalRegion, Member, ImagePath } from '../shared/core/ovs.core';
import * as Extensions from './browser.model';

export enum ResortImageFormat
{
	None = 0,
	Image = 1,
	Video = 2,
	EmbeddedVideo = 3,
}
export enum ResortImageType
{
	None = 0,
	Activities = 52,
	Dining = 54,
	Hero = 56,
	Property = 58,
	Spa = 59,
	UnitType = 60,
	Destination = 61,
	Map = 62,
	FloorPlan = 64,
	Amenities = 66,
	Search = 67,
	Gallery = 68,
}


export class BookingDetail extends Entity
{
	public hasInstantConfirm: boolean;
	public isAllInclusive: boolean;
	public rciConnection: boolean;
	public useDiscountRate: boolean;
	public checkInDate: Date;
	public checkOutDate: Date;
	public cashBack: number;
	public certificateRedemptionFee: number;
	public cost: number;
	public flatTax: number;
	public price: number;
	public pricePlusTaxesAndFees: number;
	public resortFee: number;
	public savings: number;
	public serviceFee: number;
	public tax: number;
	public taxRate: number;
	public taxesAndFees: number;
	public intervalRecno: number;
	public inventoryTypeRecno: number;
	public numDays: number;
	public pointsRedeemed: number;
	public purchaseTypeRecno: number;
	public resortRecno: number;
	public colorCode: string;
	public inventoryId: string;
	public kitchen: string;
	public locationCode: string;
	public locationText: string;
	public maxPrivOccupancy: string;
	public rciId: string;
	public resortName: string;
	public unitType: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.hasInstantConfirm = source.hasInstantConfirm;
        this.isAllInclusive = source.isAllInclusive;
        this.rciConnection = source.rciConnection;
        this.useDiscountRate = source.useDiscountRate;
        this.checkInDate = Entity.mapToDate(source.checkInDate);
        this.checkOutDate = Entity.mapToDate(source.checkOutDate);
        this.cashBack = source.cashBack;
        this.certificateRedemptionFee = source.certificateRedemptionFee;
        this.cost = source.cost;
        this.flatTax = source.flatTax;
        this.price = source.price;
        this.pricePlusTaxesAndFees = source.pricePlusTaxesAndFees;
        this.resortFee = source.resortFee;
        this.savings = source.savings;
        this.serviceFee = source.serviceFee;
        this.tax = source.tax;
        this.taxRate = source.taxRate;
        this.taxesAndFees = source.taxesAndFees;
        this.intervalRecno = source.intervalRecno;
        this.inventoryTypeRecno = source.inventoryTypeRecno;
        this.numDays = source.numDays;
        this.pointsRedeemed = source.pointsRedeemed;
        this.purchaseTypeRecno = source.purchaseTypeRecno;
        this.resortRecno = source.resortRecno;
        this.colorCode = source.colorCode;
        this.inventoryId = source.inventoryId;
        this.kitchen = source.kitchen;
        this.locationCode = source.locationCode;
        this.locationText = source.locationText;
        this.maxPrivOccupancy = source.maxPrivOccupancy;
        this.rciId = source.rciId;
        this.resortName = source.resortName;
        this.unitType = source.unitType;
    }
}
export class BookingResult extends Entity
{
	public creditCardDeclined: boolean;
	public bookingComplete: boolean;
	public bookingNumber: string;
	public comment: string;
	public error: string;
	public adults: number;
	public children: number;
	public insurance: number;
	public insuranceChosen: boolean;
	public upgradeFee: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.creditCardDeclined = source.creditCardDeclined;
        this.bookingComplete = source.bookingComplete;
        this.bookingNumber = source.bookingNumber;
        this.comment = source.comment;
        this.error = source.error;
        this.adults = source.adults;
        this.children = source.children;
        this.insurance = source.insurance;
        this.insuranceChosen = source.insuranceChosen;
        this.upgradeFee = source.upgradeFee;
    }
}
export class BookingValues extends Entity
{
	public terms: string;
	public insuranceDeclined: string;
	public insurancePurchased: string;
	public insurance: string;
	public ccTypes: Array<string>;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.terms = source.terms;
        this.insuranceDeclined = source.insuranceDeclined;
        this.insurancePurchased = source.insurancePurchased;
        this.insurance = source.insurance;
        this.ccTypes = source.ccTypes;
    }
}
export class ClientVersion extends Entity
{
	public Version: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.Version = source.Version;
    }
}
export class CobrandCreditCardType extends Entity
{
	public id: number;
	public hasCvv: boolean;
	public hasExpirationDate: boolean;
	public name: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.id = source.id;
        this.hasCvv = source.hasCvv;
        this.hasExpirationDate = source.hasExpirationDate;
        this.name = source.name;
    }
}
export class CobrandInfo extends Entity
{
	public hasCashBack: boolean;
	public hasDbc: boolean;
	public hasReward: boolean;
	public hasVacationCash: boolean;
	public hasOnlineBooking: boolean;
	public hasLocaleDropDown: boolean;
	public memberRequiredForBook: boolean;
	public memberRequiredForSearch: boolean;
	public showPricePerDay: boolean;
	public showRewardPerDay: boolean;
	public showLandPrices: boolean;
	public showPricing: boolean;
	public cashBackMaximum: number;
	public id: number;
	public dbcName: string;
	public memberLoginUrl: string;
	public name: string;
	public insurance: CobrandInsurance;
	public creditCardList: Array<CobrandCreditCardType>;
	public purchaseTypeList: Array<CobrandPurchaseType>;
	public searchLocaleList: Array<SearchLocale>;
	public purchaseTerms: string;
	public hasGoogleTagManager: boolean;
	public googleTagManagerContainerId: string;
	public defaultSearchMonthsAhead: number;
	public defaultNameId: number;
	public description: string;
	public currencyId: number;
	public currencyFormat: CurrencyFormat;
	public currencyFormatList: Array<CurrencyFormat>;
	public CobrandOptions: Array<CobrandOption>;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.hasCashBack = source.hasCashBack;
        this.hasDbc = source.hasDbc;
        this.hasReward = source.hasReward;
        this.hasVacationCash = source.hasVacationCash;
        this.hasOnlineBooking = source.hasOnlineBooking;
        this.hasLocaleDropDown = source.hasLocaleDropDown;
        this.memberRequiredForBook = source.memberRequiredForBook;
        this.memberRequiredForSearch = source.memberRequiredForSearch;
        this.showPricePerDay = source.showPricePerDay;
        this.showRewardPerDay = source.showRewardPerDay;
        this.showLandPrices = source.showLandPrices;
        this.showPricing = source.showPricing;
        this.cashBackMaximum = source.cashBackMaximum;
        this.id = source.id;
        this.dbcName = source.dbcName;
        this.memberLoginUrl = source.memberLoginUrl;
        this.name = source.name;
        this.insurance = Entity.mapToEntity<CobrandInsurance>(CobrandInsurance, source.insurance);
        this.creditCardList = Entity.mapToEntityArray<CobrandCreditCardType>(CobrandCreditCardType, source.creditCardList);
        this.purchaseTypeList = Entity.mapToEntityArray<CobrandPurchaseType>(CobrandPurchaseType, source.purchaseTypeList);
        this.searchLocaleList = Entity.mapToEntityArray<SearchLocale>(SearchLocale, source.searchLocaleList);
        this.purchaseTerms = source.purchaseTerms;
        this.hasGoogleTagManager = source.hasGoogleTagManager;
        this.googleTagManagerContainerId = source.googleTagManagerContainerId;
        this.defaultSearchMonthsAhead = source.defaultSearchMonthsAhead;
        this.defaultNameId = source.defaultNameId;
        this.description = source.description;
        this.currencyId = source.currencyId;
        this.currencyFormat = Entity.mapToEntity<CurrencyFormat>(CurrencyFormat, source.currencyFormat);
        this.currencyFormatList = Entity.mapToEntityArray<CurrencyFormat>(CurrencyFormat, source.currencyFormatList);
        this.CobrandOptions = Entity.mapToEntityArray<CobrandOption>(CobrandOption, source.CobrandOptions);
    }
}
export class CobrandOption extends Entity
{
	public id: number;
	public name: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.id = source.id;
        this.name = source.name;
    }
}
export class CurrencyFormat extends Entity
{
	public id: number;
	public currencyCode: string;
	public currencySymbol: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.id = source.id;
        this.currencyCode = source.currencyCode;
        this.currencySymbol = source.currencySymbol;
    }
}
export class CobrandInsurance extends Entity
{
	public id: number;
	public checkBoxLabel: string;
	public insuranceDeclinedText: string;
	public insurancePurchasedText: string;
	public insuranceTerms: string;
	public label: string;
	public name: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.id = source.id;
        this.checkBoxLabel = source.checkBoxLabel;
        this.insuranceDeclinedText = source.insuranceDeclinedText;
        this.insurancePurchasedText = source.insurancePurchasedText;
        this.insuranceTerms = source.insuranceTerms;
        this.label = source.label;
        this.name = source.name;
    }
}
export class CobrandPurchaseType extends Entity
{
	public id: number;
	public isDiscount: boolean;
	public description: string;
	public name: string;
	public minimumPoints: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.id = source.id;
        this.isDiscount = source.isDiscount;
        this.description = source.description;
        this.name = source.name;
        this.minimumPoints = source.minimumPoints;
    }
}
export class FeaturedSearch extends Entity
{
	public searchId: number;
	public description: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.searchId = source.searchId;
        this.description = source.description;
    }
}
export class FeaturedSearchGroup extends Entity
{
	public title: string;
	public featuredSearchList: Array<FeaturedSearch>;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.title = source.title;
        this.featuredSearchList = Entity.mapToEntityArray<FeaturedSearch>(FeaturedSearch, source.featuredSearchList);
    }
}
export class HeaderDisplayOptions extends Entity
{
	public HeaderIdentifier: string;
	public HasPartnerBadge: boolean;
	public PartnerBadgeLogoUrl: string;
	public HasBackToPartnerSiteLink: boolean;
	public PartnerCssClass: string;
	public BackToPartnerSiteLinkUrl: string;
	public BackToPartnerSiteLinkHoverText: string;
    public BackToPartnerSiteLinkText: string;
    public AlreadyBookedLinkText: string;
    public AlreadyBookedLinkUrl: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.HeaderIdentifier = source.HeaderIdentifier;
        this.HasPartnerBadge = source.HasPartnerBadge;
        this.PartnerBadgeLogoUrl = source.PartnerBadgeLogoUrl;
        this.HasBackToPartnerSiteLink = source.HasBackToPartnerSiteLink;
        this.PartnerCssClass = source.PartnerCssClass;
        this.BackToPartnerSiteLinkUrl = source.BackToPartnerSiteLinkUrl;
        this.BackToPartnerSiteLinkHoverText = source.BackToPartnerSiteLinkHoverText;
        this.BackToPartnerSiteLinkText = source.BackToPartnerSiteLinkText;
        this.AlreadyBookedLinkText = source.AlreadyBookedLinkText;
        this.AlreadyBookedLinkUrl = source.AlreadyBookedLinkUrl;

    }
}
export class InventoryPrice extends Entity
{
	public restrictBooking: boolean;
	public price: number;
	public reward: number;
	public savings: number;
	public purchaseTypeCategoryId: number;
	public points: number;
	public purchaseTypeId: number;
	public upgradeCobrandId: number;
	public upgradePurchaseTypeId: number;
	public purchaseTypeName: string;
	public priceText: string;
	public rewardText: string;
	public upgradeCertificateNumber: string;
	public upgradeAuthorizationCode: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.restrictBooking = source.restrictBooking;
        this.price = source.price;
        this.reward = source.reward;
        this.savings = source.savings;
        this.purchaseTypeCategoryId = source.purchaseTypeCategoryId;
        this.points = source.points;
        this.purchaseTypeId = source.purchaseTypeId;
        this.upgradeCobrandId = source.upgradeCobrandId;
        this.upgradePurchaseTypeId = source.upgradePurchaseTypeId;
        this.purchaseTypeName = source.purchaseTypeName;
        this.priceText = source.priceText;
        this.rewardText = source.rewardText;
        this.upgradeCertificateNumber = source.upgradeCertificateNumber;
        this.upgradeAuthorizationCode = source.upgradeAuthorizationCode;
    }
}
export class MarketingHeroSettings extends Entity
{
	public IsDisplayEnabled: boolean;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.IsDisplayEnabled = source.IsDisplayEnabled;
    }
}
export class MarketingOffer extends Entity
{
	public sortOrder: number;
	public featuredSearchGroupList: Array<FeaturedSearchGroup>;
	public resortImage: ResortImage;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.sortOrder = source.sortOrder;
        this.featuredSearchGroupList = Entity.mapToEntityArray<FeaturedSearchGroup>(FeaturedSearchGroup, source.featuredSearchGroupList);
        this.resortImage = Entity.mapToEntity<ResortImage>(ResortImage, source.resortImage);
    }
}
export class ResortAllInclusiveRule extends Extensions.ResortAllInclusiveRuleExtension
{
	public checkInDateEnd: Date;
	public checkInDateStart: Date;
	public price: number;
	public ageEnd: number;
	public ageStart: number;
	public guestNumberEnd: number;
	public guestNumberStart: number;
	public description: string;
	public label: string;
	public unitType: string;
	public isOptional: boolean;
	public sortOrder: number;
	public unitTypeId: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.checkInDateEnd = Entity.mapToDate(source.checkInDateEnd);
        this.checkInDateStart = Entity.mapToDate(source.checkInDateStart);
        this.price = source.price;
        this.ageEnd = source.ageEnd;
        this.ageStart = source.ageStart;
        this.guestNumberEnd = source.guestNumberEnd;
        this.guestNumberStart = source.guestNumberStart;
        this.description = source.description;
        this.label = source.label;
        this.unitType = source.unitType;
        this.isOptional = source.isOptional;
        this.sortOrder = source.sortOrder;
        this.unitTypeId = source.unitTypeId;
    }
}
export class ResortAmenity extends Entity
{
	public RecNo: number;
    public Name: string;
    public Description: string;
    public Rank: number;
    public IconKey: string;


    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.RecNo = source.RecNo;
        this.Name = source.Name;
        this.Description = source.Description;
        this.Rank = source.Rank;
        this.IconKey = source.IconKey;
    }
}
export class ResortApplicationConfiguration extends ApplicationConfiguration
{
	public Availability: Array<ResortAvailability>;
	public GoogleKey: string;
	public ImageRootUrls: Array<ImagePath>;
	public Regions: Array<GeographicalRegion>;
	public Countries: Array<Country>;
	public DefaultCountryId: number;
	public Stylesheet: string;
	public AssociatedMembers: Array<Member>;
	public HasGoogleTagManager: boolean;
	public GoogleTagManagerContainerId: string;
	public DefaultSearchMonthsAhead: number;
	public HeaderDisplayOptions: HeaderDisplayOptions;
	public IsGuestCheckOutMode: boolean;
	public HasErrors: boolean;
    public ErrorRedirectUrl: string;
    public IsSessionAlive: boolean;
	public ErrorMessage: string;
	public MarketingOffers: Array<MarketingOffer>;
	public RefreshApplication: boolean;
	public SearchSettings: SearchSettings;
	public MarketingHeroSettings: MarketingHeroSettings;
    public MemberClassId: string;
    public MemberClass: string;
	public UpgradeMemberClassId: string;
    public UpgradeLabels: UpgradeLabels;
    public CobrandOptions: Array<CobrandOption>
    public DocOptionId: string;
    public Brand: string;
    public AgentName: string;
    public AgentId: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.Availability = Entity.mapToEntityArray<ResortAvailability>(ResortAvailability, source.Availability);
        this.GoogleKey = source.GoogleKey;
        this.ImageRootUrls = Entity.mapToEntityArray<ImagePath>(ImagePath, source.ImageRootUrls);
        this.Regions = Entity.mapToEntityArray<GeographicalRegion>(GeographicalRegion, source.Regions);
        this.Countries = Entity.mapToEntityArray<Country>(Country, source.Countries);
        this.DefaultCountryId = source.DefaultCountryId;
        this.Stylesheet = source.Stylesheet;
        this.AssociatedMembers = Entity.mapToEntityArray<Member>(Member, source.AssociatedMembers);
        this.HasGoogleTagManager = source.HasGoogleTagManager;
        this.GoogleTagManagerContainerId = source.GoogleTagManagerContainerId;
        this.DefaultSearchMonthsAhead = source.DefaultSearchMonthsAhead;
        this.HeaderDisplayOptions = Entity.mapToEntity<HeaderDisplayOptions>(HeaderDisplayOptions, source.HeaderDisplayOptions);
        this.IsGuestCheckOutMode = source.IsGuestCheckOutMode;
        this.HasErrors = source.HasErrors;
        this.ErrorRedirectUrl = source.ErrorRedirectUrl;
        this.ErrorMessage = source.ErrorMessage;
        this.MarketingOffers = Entity.mapToEntityArray<MarketingOffer>(MarketingOffer, source.MarketingOffers);
        this.RefreshApplication = source.RefreshApplication;
        this.SearchSettings = Entity.mapToEntity<SearchSettings>(SearchSettings, source.SearchSettings);
        this.MarketingHeroSettings = Entity.mapToEntity<MarketingHeroSettings>(MarketingHeroSettings, source.MarketingHeroSettings);
        this.MemberClassId = source.MemberClassId;
        this.MemberClass = source.MemberClass;
        this.UpgradeMemberClassId = source.UpgradeMemberClassId;
        this.UpgradeLabels = Entity.mapToEntity<UpgradeLabels>(UpgradeLabels, source.UpgradeLabels);
        this.IsSessionAlive = source.IsSessionAlive;
        this.CobrandOptions = Entity.mapToEntityArray<CobrandOption>(CobrandOption, source.CobrandOptions);
        this.DocOptionId = source.DocOptionId;
        this.Brand = source.Brand;
        this.AgentName = source.AgentName;
        this.AgentId = source.AgentId;
    }
}
export class ResortAvailability extends Extensions.ResortAvailabilityExtension
{
	public Month: number;
	public Year: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.Month = source.Month;
        this.Year = source.Year;
    }
}
export class ResortBooking extends Entity
{
	public HasInsurance: boolean;
	public FirstName: string;
	public LastName: string;
	public PhoneNumber: string;
	public EmailAddress: string;
	public Fax: string;
	public CreditCardName: string;
	public CreditCardNumber: string;
	public CreditCardExpirationYear: string;
	public CreditCardExpirationMonth: string;
	public CreditCardVerification: string;
	public CreditCardType: number;
	public CreditCardTypeName: string;
	public Address: Address;
	public Guests: Array<ResortGuest>;
	public Discount: number;
	public VacationCashDiscount: number;
	public IsInstantConfirm: boolean;
	public Comments: string;
	public ResortId: string;
	public InventoryId: string;
	public IntervalId: number;
	public CheckInDate: Date;
	public CheckOutDate: Date;
	public PurchaseTypeId: number;
	public CommissionColor: string;
	public IsComplete: boolean;
	public GrandTotal: number;
	public AllInclusiveFees: number;
	public MemberInfo: Member;
	public BrandName: string;
	public StoreType: string;
	public BreakIt: string;
	public ResortInventory: ResortInventory;
	public IsUpgradeAvailable: boolean;
	public IsUpgradeMembershipSelected: boolean;
	public UpgradeFee: number;
	public UpgradeCobrandId: number;
    public UpgradePurchaseTypeId: number;
    public numberOfChildren: number;
    public numberOfAdults: number;
    public guestAges: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.HasInsurance = source.HasInsurance;
        this.FirstName = source.FirstName;
        this.LastName = source.LastName;
        this.PhoneNumber = source.PhoneNumber;
        this.EmailAddress = source.EmailAddress;
        this.Fax = source.Fax;
        this.CreditCardName = source.CreditCardName;
        this.CreditCardNumber = source.CreditCardNumber;
        this.CreditCardExpirationYear = source.CreditCardExpirationYear;
        this.CreditCardExpirationMonth = source.CreditCardExpirationMonth;
        this.CreditCardVerification = source.CreditCardVerification;
        this.CreditCardType = source.CreditCardType;
        this.CreditCardTypeName = source.CreditCardTypeName;
        this.Address = Entity.mapToEntity<Address>(Address, source.Address);
        this.Guests = Entity.mapToEntityArray<ResortGuest>(ResortGuest, source.Guests);
        this.Discount = source.Discount;
        this.VacationCashDiscount = source.VacationCashDiscount;
        this.IsInstantConfirm = source.IsInstantConfirm;
        this.Comments = source.Comments;
        this.ResortId = source.ResortId;
        this.InventoryId = source.InventoryId;
        this.IntervalId = source.IntervalId;
        this.CheckInDate = Entity.mapToDate(source.CheckinDate);
        this.CheckOutDate = Entity.mapToDate(source.CheckoutDate);
        this.PurchaseTypeId = source.PurchaseTypeId;
        this.CommissionColor = source.CommissionColor;
        this.IsComplete = source.IsComplete;
        this.GrandTotal = source.GrandTotal;
        this.AllInclusiveFees = source.AllInclusiveFees;
        this.MemberInfo = Entity.mapToEntity<Member>(Member, source.MemberInfo);
        this.BrandName = source.BrandName;
        this.StoreType = source.StoreType;
        this.BreakIt = source.BreakIt;
        this.ResortInventory = Entity.mapToEntity<ResortInventory>(ResortInventory, source.ResortInventory);
        this.IsUpgradeAvailable = source.IsUpgradeAvailable;
        this.IsUpgradeMembershipSelected = source.IsUpgradeMembershipSelected;
        this.UpgradeFee = source.UpgradeFee;
        this.UpgradeCobrandId = source.UpgradeCobrandId;
        this.UpgradePurchaseTypeId = source.UpgradePurchaseTypeId;
    }
}
export class ResortDetail extends Extensions.ResortDetailExtension
{
	public hasInventory: boolean;
	public hasInstantConfirm: boolean;
	public id: string;
	public latitude: number;
	public longitude: number;
	public startingFrom: number;
	public address1: string;
	public address2: string;
	public address3: string;
	public address4: string;
	public checkInTime: string;
	public checkOutTime: string;
	public city: string;
	public country: string;
	public distanceToAirport: string;
	public nearestAirport: string;
	public phone: string;
	public resortDescription: string;
	public resortName: string;
	public state: string;
	public zip: string;
	public offSiteAmenityList: Array<ResortAmenity>;
	public onSiteAmenityList: Array<ResortAmenity>;
	public unitAmenityList: Array<ResortAmenity>;
	public resortImageList: Array<ResortImage>;
	public resortImageTypeList: Array<ResortImageTypeDetail>;
	public resortInventoryList: Array<ResortInventory>;
	public isAllInclusive: boolean;
    public isPreferred: boolean;
    public isExclusive: boolean;
	public overview: string;
	public essentialInformation: string;
	public allInclusiveInformation: string;
	public guestInformation: string;
	public urgentInformation: string;
	public resortLifestyleList: Array<ResortLifestyle>;
    public resortAllInclusiveRuleList: Array<ResortAllInclusiveRule>;
    public resortCreditAmountUsd: number;
    public resortCreditDetails: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.hasInventory = source.hasInventory;
        this.hasInstantConfirm = source.hasInstantConfirm;
        this.id = source.id;
        this.latitude = source.latitude;
        this.longitude = source.longitude;
        this.startingFrom = source.startingFrom;
        this.address1 = source.address1;
        this.address2 = source.address2;
        this.address3 = source.address3;
        this.address4 = source.address4;
        this.checkInTime = source.checkInTime;
        this.checkOutTime = source.checkOutTime;
        this.city = source.city;
        this.country = source.country;
        this.distanceToAirport = source.distanceToAirport;
        this.nearestAirport = source.nearestAirport;
        this.phone = source.phone;
        this.resortDescription = source.resortDescription;
        this.resortName = source.resortName;
        this.state = source.state;
        this.zip = source.zip;
        this.offSiteAmenityList = Entity.mapToEntityArray<ResortAmenity>(ResortAmenity, source.offSiteAmenityList);
        this.onSiteAmenityList = Entity.mapToEntityArray<ResortAmenity>(ResortAmenity, source.onSiteAmenityList);
        this.unitAmenityList = Entity.mapToEntityArray<ResortAmenity>(ResortAmenity, source.unitAmenityList);
        this.resortImageList = Entity.mapToEntityArray<ResortImage>(ResortImage, source.resortImageList);
        this.resortImageTypeList = Entity.mapToEntityArray<ResortImageTypeDetail>(ResortImageTypeDetail, source.resortImageTypeList);
        this.resortInventoryList = Entity.mapToEntityArray<ResortInventory>(ResortInventory, source.resortInventoryList);
        this.isAllInclusive = source.isAllInclusive;
        this.isPreferred = source.isPreferred;
        this.isExclusive = source.isExclusive;
        this.overview = source.overview;
        this.essentialInformation = source.essentialInformation;
        this.allInclusiveInformation = source.allInclusiveInformation;
        this.guestInformation = source.guestInformation;
        this.urgentInformation = source.urgentInformation;
        this.resortLifestyleList = Entity.mapToEntityArray<ResortLifestyle>(ResortLifestyle, source.resortLifestyleList);
        this.resortAllInclusiveRuleList = Entity.mapToEntityArray<ResortAllInclusiveRule>(ResortAllInclusiveRule, source.resortAllInclusiveRuleList);
        this.resortCreditDetails = source.resortCreditDetails;
        this.resortCreditAmountUsd = source.resortCreditAmountUsd;
    }
}
export class ResortDuration extends Entity
{
	public count: number;
	public duration: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.count = source.count;
        this.duration = source.duration;
    }
}
export class ResortGuest extends Extensions.ResortGuestExtension
{
	public DateOfBirth: Date;
	public FirstName: string;
	public LastName: string;
	public CellPhone: string;
	public IsTextMessagingApproved: boolean;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.DateOfBirth = Entity.mapToDate(source.DateOfBirth);
        this.FirstName = source.FirstName;
        this.LastName = source.LastName;
        this.CellPhone = source.CellPhone;
        this.IsTextMessagingApproved = source.IsTextMessagingApproved;
    }
}
export class ResortImage extends Extensions.ResortImageExtension
{
	public title: string;
	public description: string;
	public imageType: ResortImageType;
	public imagePath: number;
	public fileName: string;
	public imageFormat: ResortImageFormat;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.title = source.title;
        this.description = source.description;
        this.imageType = source.imageType;
        this.imagePath = source.imagePath;
        this.fileName = source.fileName;
        this.imageFormat = source.imageFormat;
    }
}
export class ResortImageTypeDetail extends Entity
{
	public imageType: ResortImageType;
	public title: string;
	public description: string;
	public priority: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.imageType = source.imageType;
        this.title = source.title;
        this.description = source.description;
        this.priority = source.priority;
    }
}

export class ResortInventory extends Extensions.ResortInventoryExtension
{
	public checkInDate: Date;
	public checkOutDate: Date;
	public certificateRedemptionFee: number;
	public cost: number;
	public discountRate: number;
	public flatTax: number;
	public price: number;
	public resortFee: number;
	public savings: number;
	public serviceFee: number;
	public tax: number;
	public taxRate: number;
	public cashBack: number;
	public adultOccupancy: number;
    public childOccupancy: number;
    public altAdultOccupancy: number;
    public altChildOccupancy: number;
	public intervalId: number;
	public inventoryType: number;
	public maxOccupancy: number;
	public nights: number;
	public points: number;
	public discountLabel: string;
	public purchaseLabel: string;
	public commissionColor: string;
	public id: string;
	public kitchen: string;
	public unitType: string;
    public unitTypeDescription: string;
    public unitTypeDescriptionId: number;
    public unitBeddingTypes: Array<string>;
	public unitTypeName: string;
	public iceWeek: boolean;
	public discountPurchaseTypeId: number;
	public purchaseTypeId: number;
	public unitTypeImageList: Array<ResortImage>;
	public sources: Array<string>;
	public unitTypeId: number;
	public reward: number;
	public rewardActionLabel: string;
	public rewardLabel: string;
	public rewardType: number;
	public resortInventoryPriceList: Array<InventoryPrice>;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.checkInDate = Entity.mapToDate(source.checkInDate);
        this.checkOutDate = Entity.mapToDate(source.checkOutDate);
        this.certificateRedemptionFee = source.certificateRedemptionFee;
        this.cost = source.cost;
        this.discountRate = source.discountRate;
        this.flatTax = source.flatTax;
        this.price = source.price;
        this.resortFee = source.resortFee;
        this.savings = source.savings;
        this.serviceFee = source.serviceFee;
        this.tax = source.tax;
        this.taxRate = source.taxRate;
        this.cashBack = source.cashBack;
        this.adultOccupancy = source.adultOccupancy;
        this.childOccupancy = source.childOccupancy;
        this.altAdultOccupancy = source.altAdultOccupancy;
        this.altChildOccupancy = source.altChildOccupancy;
        this.intervalId = source.intervalId;
        this.inventoryType = source.inventoryType;
        this.maxOccupancy = source.maxOccupancy;
        this.nights = source.nights;
        this.points = source.points;
        this.discountLabel = source.discountLabel;
        this.purchaseLabel = source.purchaseLabel;
        this.commissionColor = source.commissionColor;
        this.id = source.id;
        this.kitchen = source.kitchen;
        this.unitType = source.unitType;
        this.unitTypeDescription = source.unitTypeDescription;
        this.unitTypeDescriptionId = source.unitTypeDescriptionId;
        this.unitBeddingTypes = source.unitBeddingTypes;
        this.unitTypeName = source.unitTypeName;
        this.iceWeek = source.iceWeek;
        this.discountPurchaseTypeId = source.discountPurchaseTypeId;
        this.purchaseTypeId = source.purchaseTypeId;
        this.unitTypeImageList = Entity.mapToEntityArray<ResortImage>(ResortImage, source.unitTypeImageList);
        this.sources = source.sources;
        this.unitTypeId = source.unitTypeId;
        this.reward = source.reward;
        this.rewardActionLabel = source.rewardActionLabel;
        this.rewardLabel = source.rewardLabel;
        this.rewardType = source.rewardType;
        this.resortInventoryPriceList = Entity.mapToEntityArray<InventoryPrice>(InventoryPrice, source.resortInventoryPriceList);
    }
}
export class ResortLifestyle extends Entity
{
	public lifestyleRecno: number;
	public name: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.lifestyleRecno = source.lifestyleRecno;
        this.name = source.name;
    }
}
export class ResortOccupancy extends Entity
{
	public adultOccupancy: number;
	public childOccupancy: number;
	public maxOccupancy: number;
    public privateOccupancy: number;
    public altAdultOccupancy: number;
    public altChildOccupancy: number;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.adultOccupancy = source.adultOccupancy;
        this.childOccupancy = source.childOccupancy;
        this.maxOccupancy = source.maxOccupancy;
        this.privateOccupancy = source.privateOccupancy;
        this.altAdultOccupancy = source.altAdultOccupancy;
        this.altChildOccupancy = source.altChildOccupancy;
    }
}
export class ResortOutlook extends Entity
{
	public availableUnits: number;
	public date: Date;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.availableUnits = source.availableUnits;
        this.date = Entity.mapToDate(source.date);
    }
}

export class ResortFeaturedAmenity extends Entity
{
    public featuredAmenityRecno: number;
    public name: string;
    public description: string;
    public rank: number;
    public iconKey: string;

    public mapFrom(source: any): void {
        super.mapFrom(source);
        this.featuredAmenityRecno = source.featuredAmenityRecno;
        this.name = source.name;
        this.description = source.description;
        this.rank = source.rank;
        this.iconKey = source.iconKey;
    }
}

export class ResortOnsiteAmenity extends Entity {
    public onsiteAmenityRecno: number;
    public name: string;
    public description: string;
    public rank: number;
    public iconKey: string;

    public mapFrom(source: any): void {
        super.mapFrom(source);
        this.onsiteAmenityRecno = source.onsiteAmenityRecno;
        this.name = source.name;
        this.description = "";
        this.rank = source.rank;
        this.iconKey = source.iconKey;
    }
}
export class ResortSummary extends Extensions.ResortSummaryExtension
{
	public id: string;
	public resortName: string;
	public resortDescription: string;


    public hasInventory: boolean;
	public hasInstantConfirm: boolean;
	public startingFrom: number;
	public startingFromDiscount: number;
	public startingFromPurchase: number;
	public city: string;
	public state: string;
	public country: string;
	public isAllInclusive: boolean;
    public isPreferred: boolean;
    public isExclusive: boolean;
    public discountLabel: string;
	public resortImageList: Array<ResortImage>;
	public resortOutlookList: Array<ResortOutlook>;
	public resortDurationList: Array<ResortDuration>;
	public resortOccupancyList: Array<ResortOccupancy>;
	public distanceFromSearch: number;
	public rewardsUpTo: number;
    public rewardActionLabel: string;
    public rewardLabel: string;
    public rewardType: number;
    public rewardPercentageUpTo: number;
    public checkInDate: string;
    public resortFeaturedAmenitiesList: Array<ResortFeaturedAmenity>;
    public resortOnsiteAmenitiesList: Array<ResortOnsiteAmenity>;
    public resortCreditAmountUsd: number;
    public resortCreditDetails: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.id = source.id;
        this.resortName = source.resortName;
        this.resortDescription = source.resortDescription;
        this.hasInventory = source.hasInventory;
        this.hasInstantConfirm = source.hasInstantConfirm;
        this.startingFrom = source.startingFrom;
        this.startingFromDiscount = source.startingFromDiscount;
        this.startingFromPurchase = source.startingFromPurchase;
        this.city = source.city;
        this.state = source.state;
        this.country = source.country;
        this.isAllInclusive = source.isAllInclusive;
        this.isPreferred = source.isPreferred;
        this.resortImageList = Entity.mapToEntityArray<ResortImage>(ResortImage, source.resortImageList);
        this.resortOutlookList = Entity.mapToEntityArray<ResortOutlook>(ResortOutlook, source.resortOutlookList);
        this.resortDurationList = Entity.mapToEntityArray<ResortDuration>(ResortDuration, source.resortDurationList);
        this.resortOccupancyList = Entity.mapToEntityArray<ResortOccupancy>(ResortOccupancy, source.resortOccupancyList);
        this.distanceFromSearch = source.distanceFromSearch;
        this.rewardsUpTo = source.rewardsUpTo;
        this.rewardActionLabel = source.rewardActionLabel;
        this.rewardLabel = source.rewardLabel;
        this.rewardType = source.rewardType;
        this.rewardPercentageUpTo = source.rewardPercentageUpTo;
        this.checkInDate = source.checkInDate;
        this.resortFeaturedAmenitiesList = Entity.mapToEntityArray<ResortFeaturedAmenity>(ResortFeaturedAmenity, source.resortFeaturedAmenitiesList);
        this.resortOnsiteAmenitiesList = Entity.mapToEntityArray<ResortOnsiteAmenity>(ResortOnsiteAmenity, source.resortOnsiteAmenitiesList);
        this.isExclusive = source.isExclusive;
        this.discountLabel = source.discountLabel;
        this.resortCreditAmountUsd = source.resortCreditAmountUsd;
        this.resortCreditDetails = source.resortCreditDetails;
    }
}
export class SearchLocale extends Entity
{
	public CountryId: number;
	public StateId: number;
	public City: string;
	public Country: string;
	public Latitude: string;
	public Longitude: string;
	public State: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.CountryId = source.CountryId;
        this.StateId = source.StateId;
        this.City = source.City;
        this.Country = source.Country;
        this.Latitude = source.Latitude;
        this.Longitude = source.Longitude;
        this.State = source.State;
    }
}
export class SearchSettings extends Entity
{
	public IsFullWidthEnabled: boolean;
	public IsRoundedThemeEnabled: boolean;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.IsFullWidthEnabled = source.IsFullWidthEnabled;
        this.IsRoundedThemeEnabled = source.IsRoundedThemeEnabled;
    }
}
export class SessionValidationRequest extends Entity
{
	public IntervalId: number;
	public InventoryId: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.IntervalId = source.IntervalId;
        this.InventoryId = source.InventoryId;
    }
}
export class SessionValidationResult extends Entity
{
	public IsSessionValid: boolean;
	public ErrorMessage: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.IsSessionValid = source.IsSessionValid;
        this.ErrorMessage = source.ErrorMessage;
    }
}
export class UpgradeLabels extends Entity
{
	public CheckoutDialogTitle: string;
	public CheckoutDialogMessage: string;
	public CheckoutDialogYesText: string;
	public CheckoutDialogNoText: string;

    public mapFrom(source: any): void
    {
        super.mapFrom(source);
        this.CheckoutDialogTitle = source.CheckoutDialogTitle;
        this.CheckoutDialogMessage = source.CheckoutDialogMessage;
        this.CheckoutDialogYesText = source.CheckoutDialogYesText;
        this.CheckoutDialogNoText = source.CheckoutDialogNoText;
    }
}







// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/models/presentation.model.ts